// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"da57af60","345":"7d6854d1","559":"d53f5b30"}[chunkId] + ".chunk.css";
};